export default __webpack_public_path__ + "static/insgnitus-cb56a1356d796264e979645291e74880.png";